import { ASSIGN_IMAGE_EDITOR_IMAGE_64, INIT_IMAGE_EDITOR, PROCESS_IMAGE } from "../uiConstants";
export const initImageEditor = () => ({
  type: INIT_IMAGE_EDITOR,
  payload: {}
});
export const assignImageEditorImage64 = ({
  image64
}) => ({
  type: ASSIGN_IMAGE_EDITOR_IMAGE_64,
  payload: {
    image64
  }
});
export const processImage = ({
  processedImage64
}) => ({
  type: PROCESS_IMAGE,
  payload: {
    processedImage64
  }
});